import { FormProductsList } from './FormProductsList'

export default FormProductsList
